import { useMutation, useQuery } from "react-query";
import {
  addInvoice,
  cancelInvoice,
  getInvoice,
  getInvoices,
  Http_GET_Invoice,
  payInvoice,
} from "./service";
import { AxiosError } from "axios";
import { useErrorHandler } from "../../../../hooks/useErrorHandler";
import useSuccessHandler from "../../../../hooks/useSuccessHandler";
import { Form_Create_Invoice } from "../../form/retur/FormRetur";

export const useAddInvoice = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast, redirect } = useSuccessHandler();

  return useMutation({
    mutationKey: "addInvoice",
    mutationFn: ({
      customer_name,
      invoice_date,
      invoice_status,
      invoice_type,
      payment_method_id,
      product_list,
      customer_address,
      customer_phone_number,
      payment_due_date,
      sub_dealer_id,
      description,
    }: Form_Create_Invoice) =>
      addInvoice({
        customer_name,
        invoice_date,
        invoice_status,
        invoice_type,
        payment_method_id,
        product_list,
        customer_address,
        customer_phone_number,
        payment_due_date,
        sub_dealer_id,
        description,
      }),
    onSuccess: (e) => {
      showToast("Berhasil menambahkan invoice baru");
      redirect("/invoice");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};

export const usePayInvoice = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast, redirect } = useSuccessHandler();

  return useMutation({
    mutationKey: "payInvoice",
    mutationFn: ({
      invoice_id,
      payment_method_id,
    }: {
      invoice_id: string;
      payment_method_id: string;
    }) =>
      payInvoice({
        payment_method_id,
        invoice_id,
      }),
    onSuccess: (e) => {
      showToast("Berhasil melakukan pembayaran invoice");
      redirect("/invoice");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};

export const useGetInvoices = ({
  customer_name,
  end_date,
  invoice_type,
  keyword,
  page,
  payment_method_id,
  perPage,
  start_date,
  status,
  sub_dealer_id,
}: Http_GET_Invoice) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    queryKey: `invoice-${customer_name}-${end_date}-${invoice_type}-${keyword}-${page}-${payment_method_id}-${perPage}-${start_date}-${status}-${sub_dealer_id}`,
    queryFn: () =>
      getInvoices({
        customer_name,
        end_date,
        invoice_type,
        keyword,
        page,
        payment_method_id,
        perPage,
        start_date,
        status,
        sub_dealer_id,
      }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useGetInvoice = ({ invoice_id }: { invoice_id?: string }) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    enabled: invoice_id !== undefined,
    queryKey: ["invoiceDetail", invoice_id],
    queryFn: () => getInvoice({ invoice_id }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useCancelInvoice = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast, redirect } = useSuccessHandler();

  return useMutation({
    mutationFn: ({
      invoice_id,
      description,
    }: {
      invoice_id: string;
      description: string;
    }) => cancelInvoice({ invoice_id, description }),
    onSuccess: (e) => {
      showToast("Berhasil melakukan retur invoice");
      redirect("/invoice");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};
